var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-stamp"},[_c('div',{staticClass:"c-stamp__img",style:({
      backgroundImage: ("url(https://contest2018.s3.amazonaws.com/timbre_" + (_vm.$i18n.locale) + ".png?v=1)")
    })})])}
var staticRenderFns = []

export { render, staticRenderFns }